import api from "../../../services/api";

const APIS = {
  GET_COMPANIES: "/Companies",
  GET_LOCATIONS: "/Location",
  GET_COUNTRIES_STATES: "/Location/countries-with-states",
  GET_FIELD_STAFF: "/Users/fieldstaff-names",
  ADD_LOCATION: "/Location",
  UPDATE_LOCATION: "/Location/edit-location"
};

export const getCompanies = async (pageNumber = 1, pageSize = 1000, filterText = '') => {
  try {
    let url = `${APIS.GET_COMPANIES}?PageNumber=${pageNumber}&PageSize=${pageSize}`;
    if (filterText?.trim()) {
      url += `&FilterText=${encodeURIComponent(filterText.trim())}`;
    }
    const res = await api.get(url);
    return {
      results: Array.isArray(res.data.results) ? res.data.results : [],
      totalCount: res.data.totalCount || 0,
      success: true
    };
  } catch (error) {
    return { results: [], totalCount: 0, success: false };
  }
};

export const getLocations = async (
  pageNumber = 1,
  pageSize = 1000,
  filterText = ""
) => {
  try {
    let url = `${APIS.GET_LOCATIONS}?PageNumber=${pageNumber}&PageSize=${pageSize}`;
    if (filterText?.trim()) {
      url += `&FilterText=${encodeURIComponent(filterText.trim())}`;
    }
    const res = await api.get(url);
    return {
      results: res.data,
      totalCount: res.data.totalCount || 0,
      success: true,
    };
  } catch (error) {
    return { results: [], totalCount: 0, success: false };
  }
};

export const getCountriesWithStates = async () => {
  try {
    const response = await api.get(APIS.GET_COUNTRIES_STATES);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFieldStaff = async () => {
  try {
    let response;
    try {
      response = await api.get(APIS.GET_FIELD_STAFF);
    } catch (error) {
      response = await api.get(`${APIS.GET_FIELD_STAFF}?PageNumber=1&PageSize=1000`);
    }
    if (response.data) {
      if (Array.isArray(response.data)) {
        return response.data;
      } else if (response.data.results && Array.isArray(response.data.results)) {
        return {
          results: response.data.results,
          totalCount: response.data.totalCount || 0,
          success: true
        };
      } else if (response.data.success !== undefined) {
        return response.data;
      }
    }
    return { results: [], totalCount: 0, success: false };
  } catch (error) {
    return { results: [], totalCount: 0, success: false };
  }
};

export const addLocation = async (locationData) => {
  try {
    const response = await api.post(APIS.ADD_LOCATION, locationData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLocation = async (locationData) => {
  try {
    const response = await api.put(APIS.UPDATE_LOCATION, locationData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
